import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Layout for the Partner Business OS and its sub-pages. */
export const Route = createFileRoute("/_authenticated/partner/business")({
  component: () => <Outlet />,
});
